import { Component, Input, OnInit } from '@angular/core';
import { Automezzo } from '../../models/Automezzo';

@Component({
  selector: 'app-popover-intervento-automezzi',
  templateUrl: './popover-intervento-automezzi.component.html',
  styleUrls: ['./popover-intervento-automezzi.component.scss'],
})
export class PopoverInterventoAutomezziComponent implements OnInit {
  @Input() automezzi: Automezzo[] = [];

  constructor() { }

  ngOnInit() {}

}
